import React, { useEffect, useRef, useState } from 'react';
import { getProjectFormListAPI } from '@/apis/form';
import * as echarts from 'echarts';

const EchartsPageByRate = (props) => {
    
    const chartRef = useRef(null);
    const form = props.form
    
    useEffect(() => {
        const chart = echarts.init(chartRef.current);
        const option = {
            title:{
                name:'飞行项目数'
            },
            xAxis: {
                type: 'category',
                data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: form,
                type: 'line'
            }]
        };
        chart.setOption(option);
        return () => {
            chart.dispose();
        };
    }, [form]);

    return (
        <div ref={chartRef} style={{ width: '600px', height: '400px' }}></div>
    );
};

export default EchartsPageByRate; 